<template>
  <transition name="slide-fade">
    <div class="search-component">
      <dialog-spinner v-if="requestChat" />
  
        <button @click="LeaveSearchState()" class="btn-floating backButton waves-effect transparent ">
          <i class="material-icons grey-text text-darken-3 left">close</i>
        </button>
      

      <div class="search-bar z-depth-1">
        <form @submit.prevent="() => {}" autocomplete="off">
          <input
            type="text"
            v-model="searchText"
            autocomplete="off"
            name="searchBar"
            id="searchBar"
          />
        </form>
        <button style="position: absolute; right:0px; top: 0px;" v-if="searchText !== ''" @click="$_leaveSearch()" class="btn-floating transparent waves-effect z-depth-0">
          <i class="material-icons grey-text text-darken-3"> cancel</i>
        </button>
      </div>

      <div class="search-results">
        <ul class="grid">
          <li
            class="grid-item waves-effect"
            v-for="(link, x) in searchResults"
            :key="x"
            @click="$_goto(link)"
          >
            <i v-html="link.icon" class="material-icons-outlined"></i>
            <span class="item-title indigo-text text-accent-2" v-html="link.title"></span>:
            <div class="description truncate" v-html="link.definition"></div>
          </li>
        </ul>
      </div>
      <div class="crazy-modal" v-if="selectedItem">
        <div class="crazy-modal-content">
          <div class="modal-action-top">
            <button
              @click="$_clearSelection()"
              class="btn-floating btn-small waves-effect transparent close-button"
            >
              <i class="material-icons grey-text text-darken-3 left"
                >arrow_back</i
              >
            </button>
            <div
              class="title center-align"
              v-html="selectedItem.title + `:`"
            ></div>
          </div>
          <div class="clear"></div>
          <div
            class="definition"
            v-if="isDefinition"
            v-html="selectedItem.definition"
          ></div>
          <div v-if="isDefinition" class="source definition">
            <div>Source</div>
            <span>{{ selectedItem.source }}</span>
          </div>

          <div v-if="pdfDocuments" class="pdf-block-container">
            <pdf-block
              v-if="pdfDocuments"
              :data-file="pdfDocuments.url"
            ></pdf-block>
          </div>
          <div
            class="image-gallery"
            v-else-if="imageGallery && imageGallery.length > 1"
          >
            <custom-slider :data-slides="imageGallery"></custom-slider>
          </div>
          <div
            class="single-image"
            v-else-if="
              selectedItem &&
                !isDefinition &&
                (!imageGallery || imageGallery.length < 2)
            "
          >
            <img
              v-if="selectedItem.image_gallery"
              :src="selectedItem.image_gallery[0].url"
            />
          </div>
          <div
            class="youtube-video"
            v-if="selectedItem && selectedItem.youtube_id"
          >
            <youtube
              :player-vars="playerVars"
              :video-id="selectedItem.youtube_id"
              ref="youtube"
            ></youtube>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import customSlider from "@/components/customSlider";
import PdfBlock from "@/components/pdfBlock.component.vue";
import dialogSpinner from "@/components/dialogSpinner.component";
export default {
  name: "AppSearch",
  components: {
    dialogSpinner,
    PdfBlock,
    customSlider,
  },
  props: {
    /*     dataUser: {
      type: Object
    },
    dataRoom: {
      type: Object
    } */
  },
  data() {
    return {
      playerVars: {
        modestbranding: 1,
        autoplay: 0,
        controls: 2,
        rel: 0,
        fs: 0,
        iv_load_policy: 3,
        enablejsapi: 0,
      },
      selectedItem: false,
      searchText: "",
      requestChat: false,
    };
  },
  watch: {
    $route: function(nV) {
      //  console.log(nV)
      if (nV.query.state && nV.query.state === "search" && nV.query.id) {
        if (!this.selectedItem) {
          this.selectedItem = this.helpers.find(
            (x) => x.helper_id === nV.query.id
          );
        }
      } else if (nV.query.state && nV.query.state === "search") {
        this.selectedItem = false;
      } else {
        this.$emit("state", false);
      }
      //  if(nV) this.$emit('state', false)
    },
    selectedItem: function(nV) {
      if (nV)
        this.$router.push({ query: { state: "search", id: nV.helper_id } });
    },
  },
  computed: {
    ...mapGetters({
      helpers: "Helpers/allHelpers",
    }),
    ...mapState({
      helperId: (state) => state.Helpers.helper,
    }),
    searchResults: {
      get() {
        function compare(a, b) {
          if (a.title < b.title) return -1;
          if (a.title > b.title) return 1;
          return 0;
        }

        /* return this.helpers.filter(x => (x.title+' '+x.definition).toLowerCase().includes(this.searchText.toLowerCase())).sort((a,b) => {
          return b.title > a.title ? false : true
        }, 1) */
        let theRest = this.helpers.filter((x) => x.definition !== "");
        return theRest
          .filter((x) =>
            (x.title + " " + x.definition)
              .toLowerCase()
              .includes(this.searchText.toLowerCase())
          )
          .sort(compare);
      },
    },
    pdfDocuments: {
      get() {
        return this.selectedItem.image_gallery
          ? this.selectedItem.image_gallery.find((x) => x.subtype === "pdf")
          : false;
      },
    },
    imageGallery: {
      get() {
        const imageGalleryState = this.selectedItem;
        return imageGalleryState ? imageGalleryState.image_gallery : false;
      },
    },
    isDefinition: {
      get() {
        return this.selectedItem && this.selectedItem.helper_id.includes("D")
          ? true
          : false;
      },
    },
  },
  methods: {
    $_clearSelection () {
      this.selectedItem = false
      this.$router.push({query:{state:'search'}})
    },
    LeaveSearchState() {
      this.$router.push({query:''})
    },
    $_leaveSearch() {
      /*   $emit('state', false) */
      //this.$router.go(-1)

      this.searchText = "";
    },
    $_kpEvent(e) {
      console.log(e);
    },
    $_goto(l) {
      this.selectedItem = l;
    },
    $_goBack() {
      this.$router.push({ query: {} });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-component {
  position: fixed;
  z-index: 99;
  width: 100%;
  left: 0;
  right: 0;
  padding: 8px 16px;
  height: calc(100% - 107px);
  background: white;
  top: 56px;
  .backButton {
    position: absolute;
    right: 21px;
    top: 21px;
    @media screen and (min-width: 768px) {
      right: inherit;
      left: calc(50vw + 345px);
    }
  }
  .search-bar {
    background: white;
    margin: 16px 12px 0px;
    width:calc(100% - 72px);
    border-radius: 6px;
    position: relative;
    @media screen and (min-width: 768px) {
      max-width: calc(768px - 82px);
      transform: translateX(-35px);
      margin-left: auto;
      margin-right: auto;
    }
    &::before {
      content: "search";
      font-family: "Material Icons";
      position: absolute;
      font-size: 20px;
      line-height: 38px;
      margin-left: 14px;
    }
    input[type="text"] {
      border: none !important;
      margin: 0px !important;
      box-shadow: none !important;
      padding: 0 12px 0 43px !important;
      width: calc(100% - 64px) !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 14px !important;
    }
  }
}
.modal-action-top {
  position: relative;
  max-width: 768px;
  margin: auto;
}
.search-results {
  max-height: calc(100vh - 219px);
  overflow: hidden;
  max-width: 768px;
  margin: auto;
  margin-top: 12px;
  overflow-y: scroll;
  .description {
    width: 95%;
  }
}
.grid {
  .grid-item {
    margin-bottom: 12px;
    border-bottom: 1px solid #e3e3e3;
    padding: 12px 10px 12px 8px;
    width: 100%;
    position: relative;
    &::after {
      content: "chevron_right";
      position: absolute;
      right: 6px;
      font-size: 24px;
      font-family: "Material Icons";
      top: 50%;
      transform: translateY(-50%);
    }
    i {
      font-size: 30px;
      float: left;
      margin-right: 14px;
    }
    .item-title {
      font-size: 18px;
      line-height: 1;
    }
  }
}
.crazy-modal {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: white;
  padding: 16px;
  z-index: 9;
  .title {
    font-size: 24px;
    padding: 12px 0px;
  }
  .close-button {
    position: absolute;
    left: 0;
    top: 13px;
  }
}
.definition {
  max-width: 768px;
  margin: auto;
}
.source {
  margin-top: 30px;
  div {
    font-weight: 600;
  }
  span {
    font-style: italic;
    font-size: 14px;
  }
}
.image-gallery {
  max-width: 768px;
  margin: auto;
  height: calc(100vh - 100px);
}
.single-image {
  width: 768px;
  margin: auto;
  img {
    width: 100%;
  }
}
</style>
<style lang="scss">
.pdf-block-container {
  position: absolute;
  height: calc(100% - 160px);
  width: 94%;
  max-width: 768px;
  left: 50%;
  transform: translateX(-50%);
}
.youtube-video {
  width: 100%;
  iframe {
    width: 100%;
  }
}
</style>
